module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.woff2?3efd5ba15a279377d224281c1ac26b53";